// Game Objects Data
// This file contains all the object information for easy editing

import armorQuestion from '../assets/images/objects/armor/armorQuestion.png';
import bedQuestion from '../assets/images/objects/bed/bedQuestion.png';
import canQuestion from '../assets/images/objects/can/canQuestion.png';
import carQuestion from '../assets/images/objects/car/carQuestion.png';
import chaliceQuestion from '../assets/images/objects/chalice/chaliceCard.png';
import dumbbellQuestion from '../assets/images/objects/dumbbell/dumbbellQuestion.png';
import eiffelQuestion from '../assets/images/objects/eiffel/eiffelQuestion.png';
import frameQuestion from '../assets/images/objects/frame/frameCard.png';
import gasQuestion from '../assets/images/objects/gas/gasQuestion.png';
import hotWaterQuestion from '../assets/images/objects/hotWater/hotWaterQuestion.png';
import inverterQuestion from '../assets/images/objects/inverter/inverterQuestion.png';
import lipstickQuestion from '../assets/images/objects/lipstick/lipstickQuestion.png';
import medalQuestion from '../assets/images/objects/medal/medalQuestion.png';
import miracleQuestion from '../assets/images/objects/miracle/miracleQuestion.png';
import mirrorQuestion from '../assets/images/objects/mirror/mirrorQuestion.png';
import miterQuestion from '../assets/images/objects/miter/miterQuestion.png';
import notebookQuestion from '../assets/images/objects/notebook/notebookQuestion.png';
import paintCanQuestion from '../assets/images/objects/paintCan/paintCanQuestion.png';
import panQuestion from '../assets/images/objects/pan/panQuestion.png';
import pan2Question from '../assets/images/objects/pan2/pan2Question.png';
import refrigeratorQuestion from '../assets/images/objects/refrigerator/refrigeratorQuestion.png';
import sculptureQuestion from '../assets/images/objects/sculpture/sculptureQuestion.png';
import solarPannelQuestion from '../assets/images/objects/solarPannel/solarPannelQuestion.png';
import streetQuestion from '../assets/images/objects/street/streetQuestion.png';
import supplementQuestion from '../assets/images/objects/supplement/supplementQuestion.png';
import tetrapackQuestion from '../assets/images/objects/tetrapack/tetrapackQuestion.png';
import toiletQuestion from '../assets/images/objects/toilet/toiletQuestion.png';
import trophyQuestion from '../assets/images/objects/trophy/trophyQuestion.png';
import trumpetQuestion from '../assets/images/objects/trumpet/trumpetQuestion.png';
import vaseQuestion from '../assets/images/objects/vase/vaseQuestion.png';
import waterFilterQuestion from '../assets/images/objects/waterFilter/waterFilterQuestion.png';

export const gameObjects = {
  armor: {
    id: 'armor',
    title: 'Viga',
    asset: armorQuestion,
    explorationText:
      'O aço é uma das ligas metalicas mais usadas no setor de construção por ser uma liga forte, versátil e principalmente ter uma boa resistência a oxidação.',
    question:
      'Qual liga metálica formada com ferro é uma das mais empregadas na construção civil? Se trata de uma liga muito versátil e que pode oferecer propriedades de proteção ao processo de oxidação.',
    answers: [
      { letter: 'A.', text: 'Titânio', correct: false },
      { letter: 'B.', text: 'Aço', correct: true },
      { letter: 'C.', text: 'Cromo', correct: false },
      { letter: 'D.', text: 'Cobalto', correct: false },
    ],
  },
  bed: {
    id: 'bed',
    title: 'Cama',
    asset: bedQuestion,
    explorationText:
      'Durante o século XIX o ferro foi utilizado no desenvolvimento de diversos segmentos como na indústria fabril, onde era empregado na produção de máquinas, na arquitetura, no desenvolvimento das ferrovias, entre outros. Também era comum na fabricação de mobiliários e na decoração.',
    question:
      'Durante o século XIX, esse metal foi pioneiro no desenvolvimento de diversos segmentos como na indústria fabril, onde era empregado na produção de máquinas, na arquitetura, no desenvolvimento das ferrovias, entre outros. Também era comum na fabricação de mobiliários e na decoração. Qual é o metal?',
    answers: [
      { letter: 'A.', text: 'Latão', correct: false },
      { letter: 'B.', text: 'Cobre', correct: false },
      { letter: 'C.', text: 'Ferro', correct: true },
      { letter: 'D.', text: 'Manganês', correct: false },
    ],
  },
  can: {
    id: 'can',
    title: 'Latinha',
    asset: canQuestion,
    explorationText:
      'O Alumínio é um dos metais mais utilizados na indústria de embalagens por ser leve, resistente e por conservar os produtos, pois os protege da ação da luz e da umidade e do ar.',
    question:
      'Que metal é um dos mais utilizados na indústria de embalagens por ser leve, resistente e por conservar os produtos, pois os protege da ação da luz, da umidade e do ar? Também é reconhecido por seu potencial de sustentabilidade, já que é infinitamente reciclável.',
    answers: [
      { letter: 'A.', text: 'Alumínio', correct: true },
      { letter: 'B.', text: 'Chumbo', correct: false },
      { letter: 'C.', text: 'Papelão', correct: false },
      { letter: 'D.', text: 'Ferro', correct: false },
    ],
  },
  car: {
    id: 'car',
    title: 'Bateria de carro',
    asset: carQuestion,
    explorationText:
      'O Brasil possui a maior reserva de nióbio do mundo, cerca de 94% das jazidas. A sua aplicação mais comum ocorre na indústria siderúrgica, pois ele é capaz de conferir algumas propriedades específicas ao aço, como soldabilidade, tenacidade e conformabilidade, além de maior resistência. Desse modo, é utilizado na indústria do aço, nos chamados aços microligados. Este tipo de aço é utilizado na construção de oleodutos e gasodutos e plataformas para exploração de petróleo e na construção naval. Além disso, pode ser utilizado na indústria automobilística, conferindo alta resistência mecânica, utilizados em chassis de caminhões, rodas de veículos e na fabricação de automóveis.',
    question:
      'O Brasil possui 94% das jazidas mundiais deste metal cuja maior aplicação é na indústria siderúrgica para criar os aços microligados. A adição deste metal a liga de aço confere mais soldabilidade, tenacidade, conformidade e resistência ao mesmo. No nosso dia a dia podemos encontrá-los em chassis de caminhões, rodas de veículos e na fabricação de automóveis. Que metal é esse?',
    answers: [
      { letter: 'A.', text: 'Estanho', correct: false },
      { letter: 'B.', text: 'Nióbio', correct: true },
      { letter: 'C.', text: 'Prata', correct: false },
      { letter: 'D.', text: 'Ferro', correct: false },
    ],
  },
  chalice: {
    id: 'chalice',
    title: 'Cálice',
    asset: chaliceQuestion,
    explorationText:
      'O ouro teve um papel importante na História do Brasil durante o século XVII/XVIII, conferindo grande visibilidade à região de Minas Gerais e sendo encontrado na arquitetura e objetos religiosos das igrejas mineiras.',
    question:
      'Esse metal teve um papel importante na História do Brasil durante o século XVII/XVIII, conferindo grande visibilidade à região de Minas Gerais e sendo encontrado na arquitetura das igrejas mineiras. Qual é esse metal?',
    answers: [
      { letter: 'A.', text: 'Ferro', correct: false },
      { letter: 'B.', text: 'Bronze', correct: false },
      { letter: 'C.', text: 'Cobre', correct: false },
      { letter: 'D.', text: 'Ouro', correct: true },
    ],
  },
  dumbbell: {
    id: 'dumbbell',
    title: 'Peso',
    asset: dumbbellQuestion,
    explorationText:
      'O chumbo integra o grupo dos metais pesados. Possui muitas aplicações, entre elas é comum em pesos de academia.',
    question: 'Qual metal é conhecido por ser utilizado em pesos de academia?',
    answers: [
      { letter: 'A.', text: 'Zinco', correct: false },
      { letter: 'B.', text: 'Chumbo', correct: true },
      { letter: 'C.', text: 'Ouro', correct: false },
      { letter: 'D.', text: 'Cobre', correct: false },
    ],
  },
  eiffel: {
    id: 'eiffel',
    title: 'Souvenir',
    asset: eiffelQuestion,
    explorationText:
      'A Torre Eiffel é uma estrutura de ferro produzida para a Exposição universal de 1889. Muito criticada por artistas e intelectuais daquela época, hoje é uma das obras mais reconhecidas do mundo.',
    question:
      'A Torre Eiffel foi produzida para a Exposição universal de 1889. Muito criticada por artistas e intelectuais daquela época, hoje é uma das obras mais reconhecidas do mundo. Qual é o metal de sua estrutura?',
    answers: [
      { letter: 'A.', text: 'Ferro', correct: true },
      { letter: 'B.', text: 'Chumbo', correct: false },
      { letter: 'C.', text: 'Aço', correct: false },
      { letter: 'D.', text: 'Estanho', correct: false },
    ],
  },
  frame: {
    id: 'frame',
    title: 'Fotografia',
    asset: frameQuestion,
    explorationText:
      'A prata por ser fotossensível é empregado na produção de imagens fotográficas analógicas. Possui inúmeras aplicações, embora seja mais conhecido por seu emprego no setor joalheiro',
    question:
      'Por ser fotossensível, esse metal é também empregado na produção de imagens fotográficas analógicas. Possui inúmeras aplicações, embora seja mais conhecido por seu emprego no setor joalheiro. Que metal é esse?',
    answers: [
      { letter: 'A.', text: 'Latão', correct: false },
      { letter: 'B.', text: 'Cobre', correct: false },
      { letter: 'C.', text: 'Ferro', correct: false },
      { letter: 'D.', text: 'Prata', correct: true },
    ],
  },
  gas: {
    id: 'gas',
    title: 'Botijão de gás',
    asset: gasQuestion,
    explorationText:
      'O aço também é utilizado na fabricação de botijões de gás. Neste caso a redução do peso, economia da manutenção, resistência à corrosão e um maior ciclo de vida do metal foram os fatores cruciais para que o metal seja empregado na fabricação.',
    question:
      'Para reduzir o peso, aumentar a resistência à corrosão e trazer mais economia com pintura e manutenção, os botijões de gás são geralmente fabricados com qual liga metálica?',
    answers: [
      { letter: 'A.', text: 'Ouro', correct: false },
      { letter: 'B.', text: 'Estanho', correct: false },
      { letter: 'C.', text: 'Aço', correct: true },
      { letter: 'D.', text: 'Prata', correct: false },
    ],
  },
  hotWater: {
    id: 'hotWater',
    title: 'Aquecedor solar',
    asset: hotWaterQuestion,
    explorationText:
      'O aço é uma liga de Ferro e carbono e veio a substituir o Ferro puro em muitas aplicações devido à sua ampla resistência. Sua utilização vai muito além de objetos do dia a dia, sendo empregado também em indústrias pesadas sendo encontrado em geradores, turbinas, estufas e painéis solares.',
    question:
      'O setor de energia requer materiais muito resistentes e duráveis. Para isto o ________,uma importante liga com ferro, é essencial para fabricação de motores e geradores usados para a produção de energia eólica, turbinas a vapor e gás. Também é usado de base para construção de placas solares, entre outros',
    answers: [
      { letter: 'A.', text: 'Latão', correct: false },
      { letter: 'B.', text: 'Estanho', correct: false },
      { letter: 'C.', text: 'Aço', correct: true },
      { letter: 'D.', text: 'Chumbo', correct: false },
    ],
  },
  inverter: {
    id: 'inverter',
    title: 'Inversor',
    asset: inverterQuestion,
    explorationText:
      'Ser condutor de eletricidade é uma característica comum dos metais. O cobre é bastante reconhecido por essa propriedade sendo empregado, frequentemente, no setor elétrico e de energia, como na produção das fiações e cabeamentos que utilizamos.',
    question:
      'Diversos metais conduzem eletricidade porém o ____________ apresenta um bom custo/benefício sendo o metal de escolha na produção de fios, cabos e conectores. Além da boa condutividade elétrica também possui boa condutividade térmica tendo aplicações em sistemas de ar e refrigeração.',
    answers: [
      { letter: 'A.', text: 'Ouro', correct: false },
      { letter: 'B.', text: 'Cobre', correct: true },
      { letter: 'C.', text: 'Chumbo', correct: false },
      { letter: 'D.', text: 'Prata', correct: false },
    ],
  },
  lipstick: {
    id: 'lipstick',
    title: 'Batom',
    asset: lipstickQuestion,
    explorationText:
      'O chumbo é utilizado na fabricação de tintas e outros pigmentos. No Egito antigo era empregado na produção de maquiagens e tinturas. Hoje, esse metal continua sendo utilizado na indústria cosmética, contudo em concentrações controladas, com grande rigor, e em doses baixas devido a sua toxicidade.',
    question:
      'O metal __________ é utilizado na fabricação de tintas e outros pigmentos. Era utilizado no Egito antigo para produção de maquiagens e tinturas. Hoje, esse metal continua sendo utilizado na indústria cosmética, contudo em concentrações controladas, com grande rigor, e em doses baixas devido a sua toxicidade.',
    answers: [
      { letter: 'A.', text: 'Níquel', correct: false },
      { letter: 'B.', text: 'Ferro', correct: false },
      { letter: 'C.', text: 'Chumbo', correct: true },
      { letter: 'D.', text: 'Cálcio', correct: false },
    ],
  },
  medal: {
    id: 'medal',
    title: 'Medalha',
    asset: medalQuestion,
    explorationText:
      'As medalhas vieram a substituir a tradicinal coroa de louros utilizada em competições na antiguidade. Atualmente, o ouro, a prata e o bronze são  os metais utilizados para a confecção de medalhas  distribuídas  aos três primeiros colocados.',
    question:
      'Na Antiguidade, os atletas vitoriosos nos Jogos Olímpicos recebiam uma coroa de louros, como símbolo da vitória. Atualmente, os vencedores recebem medalhas como parte da premiação. Quais são os três metais que constituem as medalhas olímpicas?',
    answers: [
      { letter: 'A.', text: 'Ouro, Ouro Branco, Ouro Rosê', correct: false },
      { letter: 'B.', text: 'Ouro, Níquel, Latão', correct: false },
      { letter: 'C.', text: 'Ouro, Prata, Bronze', correct: true },
      { letter: 'D.', text: 'Alumínio, Ferro, Cobre', correct: false },
    ],
  },
  miracle: {
    id: 'miracle',
    title: 'Milagro',
    asset: miracleQuestion,
    explorationText:
      'O estanho é usado para a produção de embalagens, como de alguns enlatados. É utilizado para a produção da chamada  folha de flandres. Por ser um metal extremamente maleável é utilizado também por artistas e artesãos. No México esse metal é frequentemente utilizado na produção dos chamados milagros, elemento da tradição artesanal e da cultura mexicana.',
    question:
      'Esse metal é usado para a produção de embalagens, como de alguns enlatados. É utilizado para a produção da chamada  folha de flandres, bastante empregada na indústria de embalagens. É um metal extremamente maleável por isso é utilizado por artistas e artesãos. No México esse metal é frequentemente utilizado na produção dos chamados milagros, elemento da tradição artesanal e da cultura mexicana.',
    answers: [
      { letter: 'A.', text: 'Cobalto', correct: false },
      { letter: 'B.', text: 'Cobre', correct: false },
      { letter: 'C.', text: 'Nióbio', correct: false },
      { letter: 'D.', text: 'Estanho', correct: true },
    ],
  },
  mirror: {
    id: 'mirror',
    title: 'Espelho',
    asset: mirrorQuestion,
    explorationText:
      'Espelhos são feitos de vidro e uma fina camada de prata responsável por refletir as imagens. Este mesmo princípio de reflexão é usado em algumas janelas de edifícios onde uma fina camada de prata ajuda a refletir a luz e manter a temperatura interna do edifício.',
    question:
      'Espelhos assim como algumas janelas de edifícios são revestidos com uma fina camada de metal para refletir luz. No caso das janelas o metal também ajuda a manter o ambiente interno fresco. Que metal seria este?',
    answers: [
      { letter: 'A.', text: 'Nióbio', correct: false },
      { letter: 'B.', text: 'Prata', correct: true },
      { letter: 'C.', text: 'Ouro', correct: false },
      { letter: 'D.', text: 'Estanho', correct: false },
    ],
  },
  miter: {
    id: 'miter',
    title: 'Esquadria',
    asset: miterQuestion,
    explorationText:
      'O Alumínio é um material bastante empregado em esquadrias, portas e janelas por ser leve e resistente à corrosão. O alumínio é uma opção que exige pouca manutenção se comparado aos outros materiais, como madeira, por exemplo.',
    question:
      'Qual metal é bastante empregado na produção de esquadrias de portas e janelas por ser leve e resistente à corrosão? As esquadrias fabricadas com esse metal exigem pouca manutenção se comparadas àquelas fabricadas com outros materiais, como madeira, por exemplo. São adequadas para ambientes com umidade como regiões litorâneas e proporcionam grande durabilidade.',
    answers: [
      { letter: 'A.', text: 'Ouro', correct: false },
      { letter: 'B.', text: 'Prata', correct: false },
      { letter: 'C.', text: 'Chumbo', correct: false },
      { letter: 'D.', text: 'Alumínio', correct: true },
    ],
  },
  notebook: {
    id: 'notebook',
    title: 'Notebook',
    asset: notebookQuestion,
    explorationText:
      'A indústria eletrônica e microeletrônica utiliza silício, um material muito abundante na terra como material básico para a produção de transistores, para chips. Nos Estados Unidos, a região que concentra um grande número de empresas de tecnologia ficou conhecida com o nome deste metal, o vale do silício',
    question:
      'A indústria eletrônica e microeletrônica utiliza um material muito abundante na terra como material básico para a produção de transistores para chips. Nos Estados Unidos, a região que concentra um grande número de empresas de tecnologia ficou conhecida com o nome deste metal.',
    answers: [
      { letter: 'A.', text: 'Prata', correct: false },
      { letter: 'B.', text: 'Cobre', correct: false },
      { letter: 'C.', text: 'Silicio', correct: true },
      { letter: 'D.', text: 'Mercúrio', correct: false },
    ],
  },
  paintCan: {
    id: 'paintCan',
    title: 'Lata de tinta',
    asset: paintCanQuestion,
    explorationText:
      'Tintas usam diversos materiais orgânicos e inorgânicos (minerais) para criar cores variadas. Por exemplo, o Óxido de Ferro para produzir vermelhos ou o Dióxido de Titânio para produzir brancos.',
    question:
      'Tintas usam diversos materiais orgânicos e inorgânicos (minerais) para criar cores variadas. Óxido de Ferro para produzir vermelhos ou o Dióxido de Titânio para produzir qual cor de tinta?',
    answers: [
      { letter: 'A.', text: 'Verde', correct: false },
      { letter: 'B.', text: 'Vermelho', correct: false },
      { letter: 'C.', text: 'Preta', correct: false },
      { letter: 'D.', text: 'Branca', correct: true },
    ],
  },
  pan: {
    id: 'pan',
    title: 'Frigideira',
    asset: panQuestion,
    explorationText:
      'As panelas e tachos de cobre são famosos na cozinha e doçaria tradicional brasileira, assim como para a produção de cachaça em alambiques tradicionais.',
    question:
      'As panelas e tachos constituídos por esse metal são famosos na cozinha e doçaria tradicional brasileira. Qual é o metal utilizado na produção dos tachos?',
    answers: [
      { letter: 'A.', text: 'Prata', correct: false },
      { letter: 'B.', text: 'Cobre', correct: true },
      { letter: 'C.', text: 'Ouro', correct: false },
      { letter: 'D.', text: 'Chumbo', correct: false },
    ],
  },
  pan2: {
    id: 'pan2',
    title: 'Panela',
    asset: pan2Question,
    explorationText:
      'A panela de ferro é apreciada por chefs de cozinha e possui uma longa tradição na culinária. Apresenta como algumas de suas principais propriedades manter o alimento quente por bastante tempo, já que esse metal possui boa condutibilidade térmica.  O Ferro é também um elemento importante para o nosso organismo e está presente em diversos alimentos, sua carência é responsável por causar doenças, como a anemia.',
    question:
      'Esta panela é apreciada por chefs, sua principal qualidade é o metal que mantém o alimento quente por bastante tempo devido sua boa condutividade térmica. Este metal, além de compor a panela, é um importante nutriente para o organismo e sua ausência é responsável por causar doenças como a anemia. De que metal é feita esta panela?',
    answers: [
      { letter: 'A.', text: 'Estanho', correct: false },
      { letter: 'B.', text: 'Ferro', correct: true },
      { letter: 'C.', text: 'Latão', correct: false },
      { letter: 'D.', text: 'Aço Conten', correct: false },
    ],
  },
  refrigerator: {
    id: 'refrigerator',
    title: 'Geladeira',
    asset: refrigeratorQuestion,
    explorationText:
      'Uma liga metálica, formada majoritariamente por ferro e carbono, é uma das ligas mais usadas hoje em dia. Seu uso é comum em nossas casas e está presente em diversos eletrodomésticos. Que liga metálica seria essa?.',
    question:
      'Uma liga metálica formada principalmente por ferro e carbono, muito usada em eletrodomésticos e utensílios domésticos. Que liga é essa?',
    answers: [
      { letter: 'A.', text: 'Aço', correct: true },
      { letter: 'B.', text: 'Alumínio', correct: false },
      { letter: 'C.', text: 'Ouro', correct: false },
      { letter: 'D.', text: 'Latão', correct: false },
    ],
  },
  sculpture: {
    id: 'sculpture',
    title: 'Escultura',
    asset: sculptureQuestion,
    explorationText:
      'O bronze é uma liga metálica  composta por Cobre e Estanho com uma boa durabilidade e maleabilidade. É o metal escolhido por diversos artistas para a fabricação de estátuas.',
    question:
      'Qual liga metálica feita, sobretudo, de cobre e estanho, tornou-se um metal bastante utilizado por artistas para a confecção de bustos e estátuas?',
    answers: [
      { letter: 'A.', text: 'Bronze', correct: true },
      { letter: 'B.', text: 'Cobre', correct: false },
      { letter: 'C.', text: 'Chumbo', correct: false },
      { letter: 'D.', text: 'Nióbio', correct: false },
    ],
  },
  solarPannel: {
    id: 'solarPannel',
    title: 'Painel Solar',
    asset: solarPannelQuestion,
    explorationText:
      'O principal componente dos painéis solares são as células de silício que são parte ativa desses painéis, ou seja, onde a energia elétrica é produzida. Esse componente é representado pelo símbolo "Si" na tabela periódica.',
    question:
      'O principal componente dos painéis solares são as células de __________, que é parte ativa desses painéis, ou seja, onde a energia elétrica é produzida. Esse componente é representado pelo símbolo "Si" na tabela periódica.',
    answers: [
      { letter: 'A.', text: 'Silicio', correct: true },
      { letter: 'B.', text: 'Ferro', correct: false },
      { letter: 'C.', text: 'Cobre', correct: false },
      { letter: 'D.', text: 'Magnésio', correct: false },
    ],
  },
  street: {
    id: 'street',
    title: 'Pavimento',
    asset: streetQuestion,
    explorationText:
      'As ruas de paralelepípedo tradicionais de bairros mais residenciais são feitas de granito. Seu custo é mais elevado porém requer menos manutenção, melhora a permeabilidade da água no solo e ajuda a reduzir a velocidade de veículos',
    question: 'Você sabe qual minério é utilizado para fazer as ruas de paralelepípedo?',
    answers: [
      { letter: 'A.', text: 'Mármore', correct: false },
      { letter: 'B.', text: 'Granito', correct: true },
      { letter: 'C.', text: 'Quartzo', correct: false },
      { letter: 'D.', text: 'Calcário', correct: false },
    ],
  },
  supplement: {
    id: 'supplement',
    title: 'Suplemento',
    asset: supplementQuestion,
    explorationText:
      'Vários metais como por exemplo o Zinco e o Ferro são essenciais para a saúde e para o funcionamento do nosso organismo. Eles são encontrados nos alimentos, mas, por vezes, quando há carência desses elementos, necessitamos de suplementação.',
    question:
      'Vários metais são essenciais para a saúde e para o funcionamento do nosso organismo. Eles são encontrados nos alimentos, mas, por vezes, quando há carência desses elementos, necessitamos de suplementação. Quais são os principais elementos metálicos utilizados na indústria farmacêutica para a produção de suplementos?',
    answers: [
      { letter: 'A.', text: 'Ferro, Zinco', correct: true },
      { letter: 'B.', text: 'Chumbo, Zinco', correct: false },
      { letter: 'C.', text: 'Paládio, Ferro', correct: false },
      { letter: 'D.', text: 'Aço, Latão', correct: false },
    ],
  },
  tetrapack: {
    id: 'tetrapack',
    title: 'Caixa de leite',
    asset: tetrapackQuestion,
    explorationText:
      'Nas embalagens Tetrapak uma pequena porcentagem de Alumínio já é capaz de proteger o alimento contra  o oxigênio e a luz bem como por manter a temperatura, conservando o alimento.',
    question:
      'Em determinados tipos de embalagens, conhecidas como Tetra Pak, o metal _________ mesmo compondo apenas 5% da embalagem é o  principal responsável por proteger contra  o oxigênio, a luz bem como por manter a temperatura para a melhor conservação do alimento.',
    answers: [
      { letter: 'A.', text: 'Aço', correct: false },
      { letter: 'B.', text: 'Alumínio', correct: true },
      { letter: 'C.', text: 'Papelão', correct: false },
      { letter: 'D.', text: 'Ferro', correct: false },
    ],
  },
  toilet: {
    id: 'toilet',
    title: 'Vaso sanitário',
    asset: toiletQuestion,
    explorationText:
      'A cerâmica branca é utilizada na fabricação de vasos sanitários. A complexidade do molde e a baixa deformação que a porcelana apresenta na queima, são fatores que contribuem para o emprego da cerâmica na fabricação dos sanitários.',
    question: 'O material mais usado para a fabricação de vasos sanitários é o/a _________',
    answers: [
      { letter: 'A.', text: 'Concreto', correct: false },
      { letter: 'B.', text: 'Areia', correct: false },
      { letter: 'C.', text: 'Óxido de Prata', correct: false },
      { letter: 'D.', text: 'Cerâmica Branca', correct: true },
    ],
  },
  trophy: {
    id: 'trophy',
    title: 'Troféu',
    asset: trophyQuestion,
    explorationText:
      'Símbolo de riqueza e utilizado como reserva monetária pelos bancos centrais dos países, esse metal é empregado na produção de moedas, troféus e medalhas, distribuído como prêmio aos melhores colocados de competições. Apesar de ser bastante conhecido pelo seu emprego na joalheria, também é um metal muito utilizado em indústrias de ponta como na eletrônica, no setor médico e aeroespacial.',
    question:
      'Símbolo de riqueza e utilizado como reserva monetária pelos bancos centrais dos países, esse metal é empregado na produção de moedas, troféus e medalhas, distribuído como prêmio aos melhores colocados de competições. Apesar de ser bastante conhecido pelo seu emprego na joalheria, também é um metal muito utilizado em indústrias de ponta como na eletrônica, no setor médico e aeroespacial.\n Qual é esse metal?',
    answers: [
      { letter: 'A.', text: 'Platina', correct: false },
      { letter: 'B.', text: 'Prata', correct: false },
      { letter: 'C.', text: 'Ouro', correct: true },
      { letter: 'D.', text: 'Titânio', correct: false },
    ],
  },
  trumpet: {
    id: 'trumpet',
    title: 'Trompete',
    asset: trumpetQuestion,
    explorationText:
      'O latão é uma liga formada por cobre e zinco. Ele é empregado na produção de alguns instrumentos musicais pois apresenta resistência mecânica e à corrosão. Do mesmo modo, essa liga possui, propriedades antibacterianas, fazendo com que as bactérias tenham dificuldades de se proliferar em superfícies desse metal, tornando-o adequado para a fabricação de instrumentos como trompete e saxofone.',
    question:
      'Diversos instrumentos, como trompete ou saxofone, são feitos de uma liga formada, principalmente, por cobre e zinco. Esta liga, além de propriedades antibacterianas, possui uma ótima resistência mecânica à corrosão. Qual o nome desta liga metálica?',
    answers: [
      { letter: 'A.', text: 'Ferro Fundido', correct: false },
      { letter: 'B.', text: 'Latão', correct: true },
      { letter: 'C.', text: 'Cobre', correct: false },
      { letter: 'D.', text: 'Prata', correct: false },
    ],
  },
  vase: {
    id: 'vase',
    title: 'Vaso',
    asset: vaseQuestion,
    explorationText:
      'A cerâmica possui uma  história antiga . As peças cerâmicas são um dos achados mais comuns  durante escavações em sítios arqueológicos. Os materiais cerâmicos apresentam grande resistência mecânica e durabilidade que  contribuem para sua conservação diante de intempéries.',
    question:
      'Qual o material/técnica  utilizado para a fabricação de vasos de plantas ornamentais? Esse material é empregado desde a antiguidade e possui como característica alta dureza e elevada resistência mecânica, mesmo em altas temperaturas.',
    answers: [
      { letter: 'A.', text: 'Areia Compactada', correct: false },
      { letter: 'B.', text: 'Barro queimado', correct: true },
      { letter: 'C.', text: 'Argila com palha', correct: false },
      { letter: 'D.', text: 'Argila desidratada e polida', correct: false },
    ],
  },
  waterFilter: {
    id: 'waterFilter',
    title: 'Filtro de barro',
    asset: waterFilterQuestion,
    explorationText:
      'Os filtros de barro (moringa) são populares nas casas brasileiras, eles filtram impurezas e ajudam a manter a temperatura da água. Tanto a vela que filtra a água quanto a estrutura da moringa são feitas de cerâmica.',
    question:
      'Os filtros de barro (moringa) são populares nas casas brasileiras, eles filtram impurezas e ajudam a manter a temperatura da água. A vela que filtra a água e a estrutura da moringa são feitos de:',
    answers: [
      { letter: 'A.', text: 'Plástico', correct: false },
      { letter: 'B.', text: 'Ferro', correct: false },
      { letter: 'C.', text: 'Areia Compactada', correct: false },
      { letter: 'D.', text: 'Cerâmica', correct: true },
    ],
  },
};

// Helper function to get object data by ID
export const getObjectData = (objectId) => {
  return gameObjects[objectId] || null;
};

// Helper function to get all object IDs
export const getAllObjectIds = () => {
  return Object.keys(gameObjects);
};
